import React from 'react';
import PropTypes from 'prop-types';

const OpenNewTabLink = ({
    title,
    url,
    ...rest
}) => {
    if (!title || !url) {
        return null;
    }
    return (
        <a
            target="_blank"
            href={url}
            type="button"
            rel="noopener noreferrer"
            {...rest}
        >
            {title}
        </a>
    );
};

OpenNewTabLink.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default OpenNewTabLink;
